<template>
  <div class="contents-area">
    <div class="sns-description">
      <v-card height="400px">
        <div>
          <strong>は交流できる<br />SNSサイトです。</strong>
        </div>
      </v-card>
    </div>
    <div class="team-description">
      <v-card height="400px">
        <div>
          <strong>は交流できる<br />SNSサイトです。</strong>
        </div>
      </v-card>
    </div>
    <div class="search-description">
      <v-card height="400px">
        <div>
          <strong>は交流できる<br />SNSサイトです。</strong>
        </div>
      </v-card>
    </div>
    <div class="facility-description">
      <v-card height="400px">
        <div>
          <strong>は交流できる<br />SNSサイトです。</strong>
        </div>
      </v-card>
    </div>
    <div class="all-description">
      <v-card height="400px">
        <div>
          <strong>は交流できる<br />SNSサイトです。</strong>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.contents-area {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  margin-top: 120px;
  background-color: #cfd8dc;
  .sns-description {
    margin-top: 30px;
  }
  .team-description {
    margin-top: 30px;
  }
  .search-description {
    margin-top: 30px;
  }
  .facility-description {
    margin-top: 30px;
  }
  .all-description {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
</style>